export default __webpack_public_path__ + "static/whiteclaw-logo-540x540-cf02ec0d49306cce22b25dd4f72c2c4b.png";